import { h, JSX } from 'preact';
import ObservingComponent from '../componentBases/observingComponent';
import CustomerCompaniesListPageProps from './customerCompaniesListPageProps';
import Card from '../containers/card';
import { CustomerCompanyTableItem } from 'core.frontend';
import Button from '../buttons/button';
import ButtonColors from '../buttons/buttonColors';
import SmartTable from '../smartTable/smartTable';
import SmartTableColumn from '../smartTable/smartTableColumn';
import VideoModalButton from '../buttons/videoModalButton';

class CustomerCompaniesListPage extends ObservingComponent<CustomerCompaniesListPageProps> {

    public componentWillMount() { }

    private buildColumns = (): SmartTableColumn<CustomerCompanyTableItem>[] => {
        const { page } = this.props;

        return [
            {
                heading: '',
                sortExpression: 'CustomerCompanies.Id',
                className: 'd-none d-md-table-cell fit-content',
                cellTemplate: (item, index) =>
                (<span>
                    {item.id}
                </span>),
            },
            {
                heading: 'Company Name',
                sortExpression: 'CustomerCompanies.Name',
                cellTemplate: (item, index) =>
                (<span className="text-increase-phone">
                    <Button
                        className="btn-link"
                        button={page.buildCustomerCompanyDetailButton(item)} />
                    {!item.isActive &&
                        <span class="text-sm text-red"> - Inactive</span>
                    }

                    <span className="d-md-none text-sm">
                        {item.url &&
                            <span>
                                <br/>
                                <a
                                    href={item.url.startsWith('http') ? item.url : `https://${item.url}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="text-blue underline"
                                >
                                    {item.url}
                                </a>
                            </span>
                        }

                        {item.phone &&
                            <span><br/>{item.phone}</span>
                        }
                    </span>
                </span>),
                appendSavingIndicator: true
            },
            {
                heading: 'URL',
                sortExpression: 'CustomerCompanies.Url',
                className: 'd-none d-md-table-cell text-sm',
                cellTemplate: (item, index) =>
                    item.url ? (
                        <a
                            href={item.url.startsWith('http') ? item.url : `https://${item.url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            class="text-sm text-blue underline"
                        >
                            {item.url}
                        </a>
                    ) : null
            },
            {
                heading: 'Phone',
                sortExpression: 'CustomerCompanies.Phone',
                className: 'd-none d-md-table-cell text-sm fit-content',
                cellTemplate: (item, index) =>
                (<span class="text-sm">
                    {item.phone}
                </span>)
            },
            {
                heading: 'Country',
                sortExpression: 'CustomerCompanies.Country',
                className: 'd-none d-xl-table-cell fit-content',
                cellTemplate: (item, index) =>
                (<span>
                    {item.country}
                </span>)
            }
        ];
    }

    public render({ page }): JSX.Element {
        return (
            <div>
                <div class="page-heading">
                    <h3>{page.title}</h3>
                </div>

                <Card
                    heading="All Customer Companies"
                    headingRightContent={
                        <div class="button-container flex">

                            <Button
                                className="btn-icon btn-lg"
                                button={page.helpButton} />

                            <Button
                                color={ButtonColors.Primary}
                                button={page.newCustomerCompanyButton} />
                        </div>
                    }>

                    <SmartTable
                        table={page.table}
                        columns={this.buildColumns()}
                        listOptionSlideContainer={page.listOptionSlideContainer} />

                </Card>
            </div>
        );
    }
}

export default CustomerCompaniesListPage;
